import { Button, ButtonVariant, Component, Label, Panel, Snackbar } from "@mcleod/components";
import { Api, HorizontalAlignment, Navigation, StringUtil } from "@mcleod/core";

interface DuplicateIdCheckData {
    id:string,
    table:string,
    screenType: string,
    navigateToUrl: string,
}

const WARNING_TITLE: string = "Duplicate Code";

export class DuplicateId {


    public static async isValidCode(data:DuplicateIdCheckData) : Promise<boolean>{
        if(StringUtil.isEmptyString(data.id)){
            return false;
        }

        return await this.checkManualCode(data.table, data.id)
        .then((response) => {
            if (response.data[0]?.is_duplicate) {
                const code = data.id;
                const snackBar = this.getDuplicateSnackbarPanel(code, data.screenType, data.navigateToUrl);
                Snackbar.showWarningSnackbar(snackBar, { persist: true, warningTitle: WARNING_TITLE });
                return false;
            } else {
                return true;
            }
        });
    }



    public static getDuplicateSnackbarPanel(id: string, type: string, url: string): Panel {
        const labelProps = { color: "white", fontSize: "large", rowBreak: false, paddingLeft: 1, paddingRight: 1, marginLeft: 0, marginRight: 0 };

        let components: Component[] = [];
        if (!StringUtil.isEmptyString(id)) {
            components = [
                new Label({ ...labelProps, caption: "The code [" }),
                new Label({ ...labelProps, caption: id }),
                new Button({ imageName: "detail", imageWidth: 20, imageHeight: 20, margin: 0, tooltip: "Click to go to " + type + " screen", color: "subtle.light", variant: ButtonVariant.round, onClick: () => this.navigateTo(url,id), rowBreak: false }),
                new Label({ ...labelProps, rowBreak: false, caption: "] is a duplicate of an existing code." }),
                new Label({ ...labelProps, caption: "Please enter a new one." })
            ];
        }
        return new Panel({ wrap: true, align: HorizontalAlignment.LEFT, fillRow: true, components: components, fillHeight: true });
    }

    static async checkManualCode(table:string, id:string): Promise<any> {
        return await Api.post("lme/dispatch/check-duplicate-code",
            {
                "id": id,
                "table": table,
            });
    }

    static navigateTo(url: string, id: string, newTab = true): void {
        Navigation.navigateTo(url + id, { newTab: newTab });
    }
}


